<template>
  <div>
    <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
// import { expose } from 'vue'; // Import expose

declare global {
  interface Window {
    grecaptcha: any;
  }
}

interface Props {
  siteKey: string;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:modelValue']);
const errorMessage = ref<string>('');

// Function to handle reCAPTCHA execution
const getToken = async () => {
  if (window.grecaptcha && window.grecaptcha.enterprise) {
    try {
      await window.grecaptcha.enterprise.ready(async () => {
        const token = await window.grecaptcha.enterprise.execute(props.siteKey, { action: 'login' });
        emit('update:modelValue', token); // Emit the token back to the parent
      });
    } catch (error) {
      errorMessage.value = 'Failed to execute reCAPTCHA.';
      console.error('Error during reCAPTCHA execution:', error);
    }
  } else {
    // errorMessage.value = 'reCAPTCHA is not available.';
    console.error('reCAPTCHA not available.');
  }
};


// Function to dynamically load reCAPTCHA Enterprise script
const loadRecaptchaScript = () => {
  return new Promise<void>((resolve, reject) => {
    if (document.querySelector(`script[src="https://www.google.com/recaptcha/enterprise.js?render=${props.siteKey}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${props.siteKey}`;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = () => {
      errorMessage.value = 'Failed to load reCAPTCHA script.';
      console.error('Failed to load reCAPTCHA script.');
      reject(new Error('Failed to load reCAPTCHA script.'));
    };
    document.head.appendChild(script);
  });
};

// Expose the onSubmit function to the parent component
defineExpose({ getToken,loadRecaptchaScript });

// Load the reCAPTCHA script on site key received
// watch(
//   () => props.siteKey,
//   async (newSiteKey) => {
//     if (newSiteKey) {
//       try {
//         await loadRecaptchaScript();
//         await getToken();
//       } catch (error) {
//         errorMessage.value = error.message;
//         console.error('Error during reCAPTCHA script loading:', error);
//       }
//     }
//   }
// );

</script>

<style scoped>
.text-danger {
  color: red;
}
</style>
